// extracted by mini-css-extract-plugin
export var boldCellText = "e6324a8bf4f10e460ba834503c97b75c-css";